module.exports = __webpack_public_path__ + "img/dots_pattern.854a4b29.svg";